module.exports = __webpack_public_path__ + "img/bottom-bg.aaa854dc.png";